export const SEARCH_INPUT_PLACEHOLDER = 'Car Make / Model';

export const CAR_MAKE_SELECT_PLACEHOLDER_TEXT = 'Car Make';

export const CHECKBOX_GROUP_EXPAND_CONTENT_INITIAL_HEIGHT = 76;

export const ENGINE_CAP_SELECT_OPTION_VALUE_LESS_THAN_661 = 'lessThan661';
export const ENGINE_CAP_SELECT_OPTION_VALUE_661_TO_1600 = '661to1600';
export const ENGINE_CAP_SELECT_OPTION_VALUE_1601_TO_2000 = '1601to2000';
export const ENGINE_CAP_SELECT_OPTION_VALUE_2001_TO_3000 = '2001to3000';
export const ENGINE_CAP_SELECT_OPTION_VALUE_MORE_THAN_3000 = 'moreThan3000';
